import type { TemplatePreviewState } from 'src/reducers/templatePreview/types'

interface RootState {
  templatePreview: TemplatePreviewState
}

export const getTemplatePreviewData = (state: RootState) => state.templatePreview.data

export const getTemplatePreviewLoading = (state: RootState) => state.templatePreview.loading

export const getTemplatePreviewError = (state: RootState) => state.templatePreview.error

export const getTemplatePreviewLastUpdatedAt = (state: RootState) =>
  state.templatePreview.lastUpdatedAt
